import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-FF7BQXOH.mjs";
import "./chunk-Y27MQZ3U.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
